//檢查是否顯示
export const checkFunction = {
    isAgent: 1,
    bonusManagementAllowed: 2,
    haveMyDailyPayAndContract: 3,
    contractPermission: 4,
    haveProportionalDividend: 5,
    TransferPointEnabled: 6,
}
//自定義頁面
export default { 
    data: function () {
        return {
            checkFunction: checkFunction,
            //个人中心
            MyAccount: [
                {name: "个人资料", href: "Center/AccountInfo", Id: 'myAccount1' },
                {name: "银行卡管理", href: "Center/BankCard", Id: 'myAccount2' },
                {name: "账户安全", href: "Center/AccountSecurity", Id: 'myAccount3' },
                {name: "彩种信息", href: "Center/AwardDetail", Id: 'myAccount4' },
                {name: "登录记录", href: "Center/LoginRecord", Id: 'myAccount5' },
            ],
            //銀行充提
            CashCenter: [
                {name: "充值", href: "Center/DepositCreate", Id: 'cashCenter1' },
                {name: "提现", href: "Center/WithdrawRequest", Id: 'cashCenter2' },
                {name: "充提记录", href: "Center/DepositAndWithdrawRecord", Id: 'cashCenter3' },
                {name: "额度转换", href: "Center/Transfer?PageType=ExternalGameTrans", Id: 'cashCenter4' },
                {name: "转换记录", href: "Center/ExternalGameTransRecord", Id: 'cashCenter5' },
                {name: "发放转点", href: "Center/Transfer?PageType=TransferPoint", Id: 'cashCenter6', checkId: checkFunction.TransferPointEnabled },
                {name: "转点记录", href: "Center/TransferPointRecord", Id: 'cashCenter7', checkId: checkFunction.TransferPointEnabled },
            ],
            //报表中心
            ReportCenter: [
                {name: "盈亏报表", href: "Center/ProfitReport?PageType=Self", Id: 'reportCenter1' },
                {name: "投注记录", href: "Center/BetRecord?PageType=Self", Id: 'reportCenter2' },
                {name: "追号记录", href: "Center/ScheduleRecord?PageType=Self", Id: 'reportCenter3' },
                {name: "账变记录", href: "Center/CashFlowRecord?PageType=Self", Id: 'reportCenter4' },
                {name: "彩种统计", href: "Center/LotteryGameStatistics?PageType=Self", Id: 'reportCenter5' },
            ],
            //用户管理
            TeamCenter: [
                {name: "团队总览", href: "Center/TrendChartStatistics", Id: 'teamCenter1' },
                {name: "团队概况", href: "Center/TrendChartOverview", Id: 'teamCenter2' },
                {name: "会员输赢统计", href: "Center/UserStatisticsReport", Id: 'teamCenter3' },
                // {name: "有效人数查询", href: "", Id: 'teamCenter' },
                {name: "开户中心", href: "Center/CreatePlayer", Id: 'teamCenter4' },
                {name: "会员管理", href: "Center/Player", Id: 'teamCenter5' },
                {name: "推广设定", href: "Center/RegisterLink", Id: 'teamCenter6' },
                {name: "待遇管理", href: "Center/BonusManagement", Id: 'teamCenter7', checkId: checkFunction.bonusManagementAllowed  },
                {name: "周期分红占成", href: "Center/ProportionalDividend", Id: 'teamCenter8', checkId: checkFunction.haveProportionalDividend  },
            ],
        }
    },
}